// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@mantine/core/styles.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@mantine/carousel/styles.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;0,1000;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900;1,1000&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Pacifico&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.pointer-events-none{
  pointer-events: none;
}
.\\!visible{
  visibility: visible !important;
}
.visible{
  visibility: visible;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.bottom-0{
  bottom: 0px;
}
.bottom-3{
  bottom: 0.75rem;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-6{
  bottom: 1.5rem;
}
.bottom-\\[-10px\\]{
  bottom: -10px;
}
.bottom-\\[-15px\\]{
  bottom: -15px;
}
.bottom-\\[-8px\\]{
  bottom: -8px;
}
.bottom-\\[10px\\]{
  bottom: 10px;
}
.left-0{
  left: 0px;
}
.left-2{
  left: 0.5rem;
}
.left-3{
  left: 0.75rem;
}
.left-4{
  left: 1rem;
}
.left-8{
  left: 2rem;
}
.left-\\[-10px\\]{
  left: -10px;
}
.left-\\[-15px\\]{
  left: -15px;
}
.left-\\[-330px\\]{
  left: -330px;
}
.left-\\[68px\\]{
  left: 68px;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-6{
  right: 1.5rem;
}
.right-\\[-14px\\]{
  right: -14px;
}
.right-\\[-15px\\]{
  right: -15px;
}
.right-\\[-17px\\]{
  right: -17px;
}
.right-\\[-25px\\]{
  right: -25px;
}
.right-\\[-4px\\]{
  right: -4px;
}
.right-\\[-5px\\]{
  right: -5px;
}
.right-\\[10px\\]{
  right: 10px;
}
.right-\\[20px\\]{
  right: 20px;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-2{
  top: 0.5rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-6{
  top: 1.5rem;
}
.top-\\[-0px\\]{
  top: -0px;
}
.top-\\[-10px\\]{
  top: -10px;
}
.top-\\[-14px\\]{
  top: -14px;
}
.top-\\[-15px\\]{
  top: -15px;
}
.top-\\[-1px\\]{
  top: -1px;
}
.top-\\[-20px\\]{
  top: -20px;
}
.top-\\[-25px\\]{
  top: -25px;
}
.top-\\[-30px\\]{
  top: -30px;
}
.top-\\[-35px\\]{
  top: -35px;
}
.top-\\[-40px\\]{
  top: -40px;
}
.top-\\[-4px\\]{
  top: -4px;
}
.top-\\[-50px\\]{
  top: -50px;
}
.top-\\[-5px\\]{
  top: -5px;
}
.top-\\[-8px\\]{
  top: -8px;
}
.top-\\[100\\%\\]{
  top: 100%;
}
.top-\\[100px\\]{
  top: 100px;
}
.top-\\[10px\\]{
  top: 10px;
}
.top-\\[110\\%\\]{
  top: 110%;
}
.top-\\[118px\\]{
  top: 118px;
}
.top-\\[20px\\]{
  top: 20px;
}
.top-\\[250px\\]{
  top: 250px;
}
.top-\\[2px\\]{
  top: 2px;
}
.top-\\[45px\\]{
  top: 45px;
}
.top-\\[50px\\]{
  top: 50px;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[00\\]{
  z-index: 00;
}
.z-\\[1000\\]{
  z-index: 1000;
}
.z-\\[10\\]{
  z-index: 10;
}
.z-\\[15\\]{
  z-index: 15;
}
.z-\\[20\\]{
  z-index: 20;
}
.z-\\[25\\]{
  z-index: 25;
}
.float-right{
  float: right;
}
.m-4{
  margin: 1rem;
}
.m-8{
  margin: 2rem;
}
.m-\\[5px\\]{
  margin: 5px;
}
.m-auto{
  margin: auto;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-28{
  margin-left: 7rem;
  margin-right: 7rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-5{
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-6{
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-\\[70px\\]{
  margin-left: 70px;
  margin-right: 70px;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-16{
  margin-bottom: 4rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-7{
  margin-bottom: 1.75rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-\\[100px\\]{
  margin-bottom: 100px;
}
.mb-\\[10px\\]{
  margin-bottom: 10px;
}
.mb-\\[180px\\]{
  margin-bottom: 180px;
}
.mb-\\[200px\\]{
  margin-bottom: 200px;
}
.mb-\\[25px\\]{
  margin-bottom: 25px;
}
.mb-\\[300px\\]{
  margin-bottom: 300px;
}
.mb-\\[30px\\]{
  margin-bottom: 30px;
}
.mb-\\[35px\\]{
  margin-bottom: 35px;
}
.mb-\\[40px\\]{
  margin-bottom: 40px;
}
.mb-\\[50px\\]{
  margin-bottom: 50px;
}
.mb-\\[5px\\]{
  margin-bottom: 5px;
}
.mb-\\[80px\\]{
  margin-bottom: 80px;
}
.mb-\\[8px\\]{
  margin-bottom: 8px;
}
.ml-0{
  margin-left: 0px;
}
.ml-10{
  margin-left: 2.5rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-6{
  margin-left: 1.5rem;
}
.ml-8{
  margin-left: 2rem;
}
.ml-\\[-12px\\]{
  margin-left: -12px;
}
.ml-\\[1px\\]{
  margin-left: 1px;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-10{
  margin-right: 2.5rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-5{
  margin-right: 1.25rem;
}
.mr-6{
  margin-right: 1.5rem;
}
.mr-8{
  margin-right: 2rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[200px\\]{
  margin-top: 200px;
}
.mt-\\[24px\\]{
  margin-top: 24px;
}
.mt-\\[250px\\]{
  margin-top: 250px;
}
.mt-\\[30px\\]{
  margin-top: 30px;
}
.mt-\\[40px\\]{
  margin-top: 40px;
}
.mt-\\[50px\\]{
  margin-top: 50px;
}
.mt-\\[80px\\]{
  margin-top: 80px;
}
.mt-auto{
  margin-top: auto;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.contents{
  display: contents;
}
.hidden{
  display: none;
}
.h-10{
  height: 2.5rem;
}
.h-12{
  height: 3rem;
}
.h-16{
  height: 4rem;
}
.h-20{
  height: 5rem;
}
.h-3{
  height: 0.75rem;
}
.h-4{
  height: 1rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-\\[100px\\]{
  height: 100px;
}
.h-\\[10px\\]{
  height: 10px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[20px\\]{
  height: 20px;
}
.h-\\[22px\\]{
  height: 22px;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[30px\\]{
  height: 30px;
}
.h-\\[32px\\]{
  height: 32px;
}
.h-\\[35px\\]{
  height: 35px;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[40px\\]{
  height: 40px;
}
.h-\\[41px\\]{
  height: 41px;
}
.h-\\[500px\\]{
  height: 500px;
}
.h-\\[50px\\]{
  height: 50px;
}
.h-\\[530px\\]{
  height: 530px;
}
.h-\\[60\\%\\]{
  height: 60%;
}
.h-\\[600px\\]{
  height: 600px;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[610px\\]{
  height: 610px;
}
.h-\\[650px\\]{
  height: 650px;
}
.h-\\[65px\\]{
  height: 65px;
}
.h-\\[80\\%\\]{
  height: 80%;
}
.h-\\[80px\\]{
  height: 80px;
}
.h-\\[90px\\]{
  height: 90px;
}
.h-\\[92vh\\]{
  height: 92vh;
}
.h-full{
  height: 100%;
}
.h-screen{
  height: 100vh;
}
.max-h-0{
  max-height: 0px;
}
.max-h-20{
  max-height: 5rem;
}
.max-h-\\[22px\\]{
  max-height: 22px;
}
.max-h-\\[36px\\]{
  max-height: 36px;
}
.max-h-\\[40px\\]{
  max-height: 40px;
}
.max-h-\\[46px\\]{
  max-height: 46px;
}
.max-h-\\[500px\\]{
  max-height: 500px;
}
.max-h-\\[50vh\\]{
  max-height: 50vh;
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-\\[100px\\]{
  min-height: 100px;
}
.min-h-\\[100vh\\]{
  min-height: 100vh;
}
.min-h-\\[200px\\]{
  min-height: 200px;
}
.min-h-\\[36px\\]{
  min-height: 36px;
}
.min-h-\\[400px\\]{
  min-height: 400px;
}
.min-h-\\[46px\\]{
  min-height: 46px;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-\\[80px\\]{
  min-height: 80px;
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.w-0{
  width: 0px;
}
.w-1\\/4{
  width: 25%;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-20{
  width: 5rem;
}
.w-3{
  width: 0.75rem;
}
.w-4{
  width: 1rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-6{
  width: 1.5rem;
}
.w-7{
  width: 1.75rem;
}
.w-8{
  width: 2rem;
}
.w-\\[1000px\\]{
  width: 1000px;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[100vw\\]{
  width: 100vw;
}
.w-\\[10px\\]{
  width: 10px;
}
.w-\\[110px\\]{
  width: 110px;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[130px\\]{
  width: 130px;
}
.w-\\[140px\\]{
  width: 140px;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[160px\\]{
  width: 160px;
}
.w-\\[170px\\]{
  width: 170px;
}
.w-\\[180px\\]{
  width: 180px;
}
.w-\\[190px\\]{
  width: 190px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[20px\\]{
  width: 20px;
}
.w-\\[230px\\]{
  width: 230px;
}
.w-\\[250px\\]{
  width: 250px;
}
.w-\\[290px\\]{
  width: 290px;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[320px\\]{
  width: 320px;
}
.w-\\[350px\\]{
  width: 350px;
}
.w-\\[35px\\]{
  width: 35px;
}
.w-\\[36px\\]{
  width: 36px;
}
.w-\\[40\\%\\]{
  width: 40%;
}
.w-\\[400px\\]{
  width: 400px;
}
.w-\\[40px\\]{
  width: 40px;
}
.w-\\[430px\\]{
  width: 430px;
}
.w-\\[450px\\]{
  width: 450px;
}
.w-\\[45px\\]{
  width: 45px;
}
.w-\\[500px\\]{
  width: 500px;
}
.w-\\[50px\\]{
  width: 50px;
}
.w-\\[55px\\]{
  width: 55px;
}
.w-\\[60px\\]{
  width: 60px;
}
.w-\\[65px\\]{
  width: 65px;
}
.w-\\[700px\\]{
  width: 700px;
}
.w-\\[70px\\]{
  width: 70px;
}
.w-\\[750px\\]{
  width: 750px;
}
.w-\\[75px\\]{
  width: 75px;
}
.w-\\[80px\\]{
  width: 80px;
}
.w-\\[820px\\]{
  width: 820px;
}
.w-\\[90px\\]{
  width: 90px;
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-screen{
  width: 100vw;
}
.min-w-0{
  min-width: 0px;
}
.min-w-\\[1000px\\]{
  min-width: 1000px;
}
.min-w-\\[100px\\]{
  min-width: 100px;
}
.min-w-\\[1700px\\]{
  min-width: 1700px;
}
.min-w-\\[170px\\]{
  min-width: 170px;
}
.min-w-\\[1800px\\]{
  min-width: 1800px;
}
.min-w-\\[192px\\]{
  min-width: 192px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[250px\\]{
  min-width: 250px;
}
.min-w-\\[272px\\]{
  min-width: 272px;
}
.min-w-\\[330px\\]{
  min-width: 330px;
}
.min-w-\\[350px\\]{
  min-width: 350px;
}
.min-w-\\[450px\\]{
  min-width: 450px;
}
.min-w-\\[500px\\]{
  min-width: 500px;
}
.min-w-\\[70px\\]{
  min-width: 70px;
}
.min-w-\\[80px\\]{
  min-width: 80px;
}
.min-w-\\[900px\\]{
  min-width: 900px;
}
.min-w-\\[960px\\]{
  min-width: 960px;
}
.min-w-full{
  min-width: 100%;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-\\[1000px\\]{
  max-width: 1000px;
}
.max-w-\\[1020px\\]{
  max-width: 1020px;
}
.max-w-\\[120px\\]{
  max-width: 120px;
}
.max-w-\\[1210px\\]{
  max-width: 1210px;
}
.max-w-\\[1325px\\]{
  max-width: 1325px;
}
.max-w-\\[1330px\\]{
  max-width: 1330px;
}
.max-w-\\[1880px\\]{
  max-width: 1880px;
}
.max-w-\\[192px\\]{
  max-width: 192px;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[250px\\]{
  max-width: 250px;
}
.max-w-\\[272px\\]{
  max-width: 272px;
}
.max-w-\\[330px\\]{
  max-width: 330px;
}
.max-w-\\[350px\\]{
  max-width: 350px;
}
.max-w-\\[400px\\]{
  max-width: 400px;
}
.max-w-\\[420px\\]{
  max-width: 420px;
}
.max-w-\\[500px\\]{
  max-width: 500px;
}
.max-w-\\[750px\\]{
  max-width: 750px;
}
.max-w-\\[900px\\]{
  max-width: 900px;
}
.max-w-\\[960px\\]{
  max-width: 960px;
}
.max-w-full{
  max-width: 100%;
}
.max-w-max{
  max-width: max-content;
}
.flex-1{
  flex: 1 1;
}
.flex-\\[3\\]{
  flex: 3 1;
}
.flex-none{
  flex: none;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.table-fixed{
  table-layout: fixed;
}
.translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-4{
  --tw-translate-y: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce{

  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce{
  animation: bounce 1s infinite;
}
@keyframes fadeIn{

  0%{
    opacity: 0;
  }

  100%{
    opacity: 1;
  }
}
.animate-fadeIn{
  animation: fadeIn 0.5s ease-in-out;
}
@keyframes ping{

  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulsate{

  0%, 100%{
    transform: scale(1);
    opacity: 1;
  }

  50%{
    transform: scale(1.05);
    opacity: 0.7;
  }
}
.animate-pulsate{
  animation: pulsate 0.5s ease-in-out 0.5s;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.cursor-pointer{
  cursor: pointer;
}
.touch-pan-y{
  --tw-pan-y: pan-y;
  touch-action: var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom);
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.place-items-center{
  place-items: center;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-2{
  gap: 0.5rem;
}
.gap-4{
  gap: 1rem;
}
.gap-8{
  gap: 2rem;
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.divide-gray-300 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-divide-opacity, 1));
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-y-visible{
  overflow-y: visible;
}
.overflow-x-scroll{
  overflow-x: scroll;
}
.overflow-y-scroll{
  overflow-y: scroll;
}
.overscroll-contain{
  overscroll-behavior: contain;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.overflow-ellipsis{
  text-overflow: ellipsis;
}
.text-ellipsis{
  text-overflow: ellipsis;
}
.whitespace-normal{
  white-space: normal;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.text-nowrap{
  text-wrap: nowrap;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-xl{
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-l{
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-l-\\[5px\\]{
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.rounded-l-xl{
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-r-3xl{
  border-top-right-radius: 1.5rem;
  border-bottom-right-radius: 1.5rem;
}
.rounded-r-xl{
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.rounded-t{
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-xl{
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.border{
  border-width: 1px;
}
.border-\\[1px\\]{
  border-width: 1px;
}
.border-\\[2px\\]{
  border-width: 2px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-b-4{
  border-bottom-width: 4px;
}
.border-l-0{
  border-left-width: 0px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-l-8{
  border-left-width: 8px;
}
.border-l-\\[5px\\]{
  border-left-width: 5px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-\\[5px\\]{
  border-top-width: 5px;
}
.border-solid{
  border-style: solid;
}
.border-dashed{
  border-style: dashed;
}
.border-\\[\\#9C9C9C\\]{
  --tw-border-opacity: 1;
  border-color: rgb(156 156 156 / var(--tw-border-opacity, 1));
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-gray-600{
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-indigo-600{
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.border-primary-color{
  --tw-border-opacity: 1;
  border-color: rgb(206 183 123 / var(--tw-border-opacity, 1));
}
.border-purchase-color{
  --tw-border-opacity: 1;
  border-color: rgb(233 216 166 / var(--tw-border-opacity, 1));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-b-blue-500{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-b-gray-100{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-b-gray-300{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-b-slate-300{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-b-white{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-l-background-color{
  --tw-border-opacity: 1;
  border-left-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-l-blue-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-l-gray-200{
  --tw-border-opacity: 1;
  border-left-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-l-white{
  --tw-border-opacity: 1;
  border-left-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-r-gray-300{
  --tw-border-opacity: 1;
  border-right-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-r-white{
  --tw-border-opacity: 1;
  border-right-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-t-gray-200{
  --tw-border-opacity: 1;
  border-top-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-t-gray-300{
  --tw-border-opacity: 1;
  border-top-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-t-purchase-color{
  --tw-border-opacity: 1;
  border-top-color: rgb(233 216 166 / var(--tw-border-opacity, 1));
}
.bg-\\[\\#383838\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(56 56 56 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#5D5D5D\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(93 93 93 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EECDC4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(238 205 196 / var(--tw-bg-opacity, 1));
}
.bg-background-color{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-base-color-yellow{
  --tw-bg-opacity: 1;
  background-color: rgb(237 241 207 / var(--tw-bg-opacity, 1));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-200{
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-400{
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-confirmed{
  --tw-bg-opacity: 1;
  background-color: rgb(167 218 221 / var(--tw-bg-opacity, 1));
}
.bg-fast-delivery{
  --tw-bg-opacity: 1;
  background-color: rgb(0 119 182 / var(--tw-bg-opacity, 1));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-600{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-800{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-400{
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-new-on-list{
  --tw-bg-opacity: 1;
  background-color: rgb(206 183 123 / var(--tw-bg-opacity, 1));
}
.bg-presales{
  --tw-bg-opacity: 1;
  background-color: rgb(245 235 223 / var(--tw-bg-opacity, 1));
}
.bg-primary-color{
  --tw-bg-opacity: 1;
  background-color: rgb(206 183 123 / var(--tw-bg-opacity, 1));
}
.bg-purchase-color{
  --tw-bg-opacity: 1;
  background-color: rgb(233 216 166 / var(--tw-bg-opacity, 1));
}
.bg-red-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}
.bg-red-400{
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-red-700{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.bg-sky-400{
  --tw-bg-opacity: 1;
  background-color: rgb(56 189 248 / var(--tw-bg-opacity, 1));
}
.bg-sky-500{
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity, 1));
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-400{
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-un-purchase-color{
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity, 1));
}
.bg-violet-400{
  --tw-bg-opacity: 1;
  background-color: rgb(167 139 250 / var(--tw-bg-opacity, 1));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-opacity-75{
  --tw-bg-opacity: 0.75;
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-l{
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-black{
  --tw-gradient-from: #000 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500{
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gradient-color-primary-one{
  --tw-gradient-from: #BDAA76 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(189 170 118 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500{
  --tw-gradient-from: #22c55e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500{
  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-500{
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-500{
  --tw-gradient-from: #eab308 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 179 8 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-white\\/90{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.9) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-black{
  --tw-gradient-to: #000 var(--tw-gradient-to-position);
}
.to-blue-700{
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}
.to-gradient-color-primary-two{
  --tw-gradient-to: #E3D8BC var(--tw-gradient-to-position);
}
.to-green-700{
  --tw-gradient-to: #15803d var(--tw-gradient-to-position);
}
.to-purple-700{
  --tw-gradient-to: #7e22ce var(--tw-gradient-to-position);
}
.to-red-700{
  --tw-gradient-to: #b91c1c var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-yellow-700{
  --tw-gradient-to: #a16207 var(--tw-gradient-to-position);
}
.object-cover{
  object-fit: cover;
}
.object-scale-down{
  object-fit: scale-down;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-16{
  padding: 4rem;
}
.p-2{
  padding: 0.5rem;
}
.p-24{
  padding: 6rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-12{
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[250px\\]{
  padding-left: 250px;
  padding-right: 250px;
}
.px-\\[80px\\]{
  padding-left: 80px;
  padding-right: 80px;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-\\[1px\\]{
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-\\[50px\\]{
  padding-top: 50px;
  padding-bottom: 50px;
}
.pb-16{
  padding-bottom: 4rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pb-\\[200px\\]{
  padding-bottom: 200px;
}
.pl-0{
  padding-left: 0px;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-\\[30px\\]{
  padding-left: 30px;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-12{
  padding-right: 3rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-8{
  padding-top: 2rem;
}
.pt-\\[2px\\]{
  padding-top: 2px;
}
.pt-\\[34px\\]{
  padding-top: 34px;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-middle{
  vertical-align: middle;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-\\[30px\\]{
  font-size: 30px;
}
.text-\\[40px\\]{
  font-size: 40px;
}
.text-\\[55px\\]{
  font-size: 55px;
}
.text-\\[80px\\]{
  font-size: 80px;
}
.text-\\[8px\\]{
  font-size: 8px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.leading-4{
  line-height: 1rem;
}
.leading-5{
  line-height: 1.25rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-\\[12px\\]{
  line-height: 12px;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-tighter{
  letter-spacing: -0.05em;
}
.text-\\[\\#666666\\]{
  --tw-text-opacity: 1;
  color: rgb(102 102 102 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9C9C9C\\]{
  --tw-text-opacity: 1;
  color: rgb(156 156 156 / var(--tw-text-opacity, 1));
}
.text-base-color-yellow{
  --tw-text-opacity: 1;
  color: rgb(237 241 207 / var(--tw-text-opacity, 1));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-fast-delivery{
  --tw-text-opacity: 1;
  color: rgb(0 119 182 / var(--tw-text-opacity, 1));
}
.text-gray-100{
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-primary-color{
  --tw-text-opacity: 1;
  color: rgb(206 183 123 / var(--tw-text-opacity, 1));
}
.text-purchase-color{
  --tw-text-opacity: 1;
  color: rgb(233 216 166 / var(--tw-text-opacity, 1));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-opacity-70{
  --tw-text-opacity: 0.7;
}
.underline{
  text-decoration-line: underline;
}
.line-through{
  text-decoration-line: line-through;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.placeholder-gray-400::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.placeholder-white::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(255 255 255 / var(--tw-placeholder-opacity, 1));
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-55{
  opacity: 0.55;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-75{
  transition-delay: 75ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-700{
  transition-duration: 700ms;
}
.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

body {
    -webkit-tap-highlight-color: transparent;
    font-family: Inter, serif;
}

.App {
}

.App-logo {
    height: 40vmin;
    pointer-events: none;
}

.message-background {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-repeat: no-repeat;
}

.placeholder-presales::placeholder {
    font-size: 12px;
    text-align: left;
}

.placeholder-left::placeholder{
  text-align: left;
    padding-left: 5px;
}

.placeholder-right::placeholder{
  text-align: right;
    padding-right: 5px;
}

@media (prefers-reduced-motion: no-preference) {
    .App-logo {
        animation: App-logo-spin infinite 20s linear;
    }
}

.App-header {
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
}

.App-link {
    color: #61dafb;
}

@keyframes App-logo-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.font-open-sans {
    font-family: 'Open Sans', sans-serif;
    color: rgb(103, 116, 142);
}

.login-header-background {
    background-image: linear-gradient(310deg, #C5B17B, #E6DAC1)
}

.text-gradient {
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;
    z-index: 1;
}

.text-gradient.text-info {
    background-image: linear-gradient(310deg, #C5B17B, #E6DAC1);
}

.text-gradient.text-info-red {
    background-image: linear-gradient(310deg, #701F1D, #FF1D14);
}

button:focus {
    outline: none;
}

.blue-gradient-button:hover {
    transform: scale(1.02);
    transition-duration: 300ms;
}

.grow-on-hover-2:hover {
    transform: scale(1.02);
    transition-duration: 300ms;
}

.grow-on-hover-5:hover {
    transform: scale(1.05);
    transition-duration: 300ms;
}

.grow-on-hover-15:hover {
    transform: scale(1.15);
    transition-duration: 300ms;
}

.login-switch-backcolor {
    background-color: #22C9FD;
}

.grow-div {
    max-height: 1000px;
    transition: max-height 0.5s ease-in;
}

.hide {
    opacity: 0;
    transition: opacity 1s linear;
    -webkit-transition: opacity 1s linear;
    -moz-transition: opacity 1s linear;
    -o-transition: opacity 1s linear;
}

.show {
    opacity: 1;
    transition: opacity 1s linear;
    -webkit-transition: opacity 1s linear;
    -moz-transition: opacity 1s linear;
    -o-transition: opacity 1s linear;
}

th {
    text-align: left;
}

td {
    text-align: left;
    padding-right: 25px;
}

.rotate-on-hover {
    display: inline-block; /* Ensure the element has a layout */
    transition: transform 0.3s ease-in-out; /* Smooth transition for rotation */
}

.rotate-on-hover:hover {
    transform: rotate(90deg); /* Rotate 90 degrees on hover */
}

.flying-image {
    position: absolute;
    width: 100px;
    height: 100px;
    transition: transform 1s ease-in-out, opacity 1s ease-in-out;
    z-index: 999;
}

input:focus {
    background-color: transparent !important;
    border-color: #f1f5f9 !important; /* slate-100 */
    outline: none;
}

input:-webkit-autofill:focus {
    box-shadow: 0 0 0px 1000px transparent inset !important;
    background-color: transparent !important;
}

input:-webkit-autofill {
    box-shadow: 0 0 0 1000px transparent inset !important;
    -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
    background-color: transparent !important;
    -webkit-text-fill-color: inherit !important;
    -webkit-transition: background-color 5000s ease-in-out 0s;
    transition: background-color 5000s ease-in-out 0s; /* Chrome autofill hack */
}

.hover\\:rotate-180:hover{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.01\\]:hover{
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.02\\]:hover{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.05\\]:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.15\\]:hover{
  --tw-scale-x: 1.15;
  --tw-scale-y: 1.15;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.1\\]:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes pulse{

  50%{
    opacity: .5;
  }
}

.hover\\:animate-pulse:hover{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.hover\\:border:hover{
  border-width: 1px;
}

.hover\\:border-slate-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}

.hover\\:border-l-gray-100:hover{
  --tw-border-opacity: 1;
  border-left-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}

.hover\\:bg-blue-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:p-1:hover{
  padding: 0.25rem;
}

.hover\\:text-black:hover{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-600:hover{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-700:hover{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-80:hover{
  opacity: 0.8;
}

.hover\\:shadow:hover{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:outline:focus-visible{
  outline-style: solid;
}

.focus-visible\\:outline-2:focus-visible{
  outline-width: 2px;
}

.focus-visible\\:outline-offset-2:focus-visible{
  outline-offset: 2px;
}

.focus-visible\\:outline-indigo-600:focus-visible{
  outline-color: #4f46e5;
}

.active\\:bg-blue-100:active{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:max-h-20{
  max-height: 5rem;
}

.group:hover .group-hover\\:border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}

.group:hover .group-hover\\:text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

@media (min-width: 640px){

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:my-8{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:mt-5{
    margin-top: 1.25rem;
  }

  .sm\\:mt-6{
    margin-top: 1.5rem;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:grid{
    display: grid;
  }

  .sm\\:w-full{
    width: 100%;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:translate-y-0{
    --tw-translate-y: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:scale-100{
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:scale-95{
    --tw-scale-x: .95;
    --tw-scale-y: .95;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:gap-4{
    gap: 1rem;
  }

  .sm\\:rounded-lg{
    border-radius: 0.5rem;
  }

  .sm\\:p-0{
    padding: 0px;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media (min-width: 768px){

  .md\\:block{
    display: block;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:flex-1{
    flex: 1 1;
  }

  .md\\:divide-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
  }
}

@media (min-width: 1024px){

  .lg\\:block{
    display: block;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:h-\\[700px\\]{
    height: 700px;
  }

  .lg\\:w-\\[1000px\\]{
    width: 1000px;
  }
}

@media (min-width: 1280px){

  .xl\\:block{
    display: block;
  }

  .xl\\:flex{
    display: flex;
  }
}

@media (min-width: 1536px){

  .\\32xl\\:mr-4{
    margin-right: 1rem;
  }

  .\\32xl\\:block{
    display: block;
  }

  .\\32xl\\:w-\\[250px\\]{
    width: 250px;
  }

  .\\32xl\\:w-\\[45px\\]{
    width: 45px;
  }

  .\\32xl\\:max-w-\\[250px\\]{
    max-width: 250px;
  }
}

@media (min-width: 1920px){

  .screen-large\\:ml-3{
    margin-left: 0.75rem;
  }

  .screen-large\\:block{
    display: block;
  }

  .screen-large\\:hidden{
    display: none;
  }

  .screen-large\\:min-w-\\[1200px\\]{
    min-width: 1200px;
  }
}

@media (min-width: 1340px){

  .screen-medium\\:ml-10{
    margin-left: 2.5rem;
  }

  .screen-medium\\:ml-\\[300px\\]{
    margin-left: 300px;
  }

  .screen-medium\\:block{
    display: block;
  }

  .screen-medium\\:flex{
    display: flex;
  }

  .screen-medium\\:hidden{
    display: none;
  }

  .screen-medium\\:w-\\[70\\%\\]{
    width: 70%;
  }

  .screen-medium\\:min-w-\\[1280px\\]{
    min-width: 1280px;
  }

  .screen-medium\\:text-left{
    text-align: left;
  }
}

@media (min-width: 1040px){

  .screen-small\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .screen-small\\:my-\\[50px\\]{
    margin-top: 50px;
    margin-bottom: 50px;
  }

  .screen-small\\:mb-8{
    margin-bottom: 2rem;
  }

  .screen-small\\:mb-\\[10px\\]{
    margin-bottom: 10px;
  }

  .screen-small\\:mb-\\[30px\\]{
    margin-bottom: 30px;
  }

  .screen-small\\:ml-14{
    margin-left: 3.5rem;
  }

  .screen-small\\:ml-6{
    margin-left: 1.5rem;
  }

  .screen-small\\:ml-\\[50px\\]{
    margin-left: 50px;
  }

  .screen-small\\:mr-2{
    margin-right: 0.5rem;
  }

  .screen-small\\:mr-4{
    margin-right: 1rem;
  }

  .screen-small\\:mt-\\[32px\\]{
    margin-top: 32px;
  }

  .screen-small\\:block{
    display: block;
  }

  .screen-small\\:flex{
    display: flex;
  }

  .screen-small\\:hidden{
    display: none;
  }

  .screen-small\\:max-h-\\[46px\\]{
    max-height: 46px;
  }

  .screen-small\\:min-h-\\[46px\\]{
    min-height: 46px;
  }

  .screen-small\\:w-\\[450px\\]{
    width: 450px;
  }

  .screen-small\\:w-\\[500px\\]{
    width: 500px;
  }

  .screen-small\\:w-\\[800px\\]{
    width: 800px;
  }

  .screen-small\\:w-\\[900px\\]{
    width: 900px;
  }

  .screen-small\\:max-w-\\[500px\\]{
    max-width: 500px;
  }

  .screen-small\\:rounded-l-3xl{
    border-top-left-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .screen-small\\:rounded-r-none{
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .screen-small\\:border-l-2{
    border-left-width: 2px;
  }

  .screen-small\\:border-l-black{
    --tw-border-opacity: 1;
    border-left-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
  }

  .screen-small\\:bg-purchase-color{
    --tw-bg-opacity: 1;
    background-color: rgb(233 216 166 / var(--tw-bg-opacity, 1));
  }

  .screen-small\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }

  .screen-small\\:pb-4{
    padding-bottom: 1rem;
  }

  .screen-small\\:pl-4{
    padding-left: 1rem;
  }

  .screen-small\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .screen-small\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .screen-small\\:text-\\[80px\\]{
    font-size: 80px;
  }

  .screen-small\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .screen-small\\:text-black{
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity, 1));
  }

  .screen-small\\:text-gray-700{
    --tw-text-opacity: 1;
    color: rgb(55 65 81 / var(--tw-text-opacity, 1));
  }

  .screen-small\\:text-purchase-color{
    --tw-text-opacity: 1;
    color: rgb(233 216 166 / var(--tw-text-opacity, 1));
  }

  .screen-small\\:shadow{
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media (max-width: 585px){

  .screen-mobile\\:block{
    display: block;
  }

  .screen-mobile\\:hidden{
    display: none;
  }
}

@media (min-width: 2300px){

  .\\34xl\\:block{
    display: block;
  }
}

@media (min-width: 2800px){

  .\\36xl\\:block{
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAOA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;;EAAnB;IAAA,sBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;AACA;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,yDAA+2T;IAC/2T,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAGI;EAAA,gBAAgB;IAChB;AADgB;;AAKhB;EAAA,iBAAiB;IACjB;AADiB;;AAIrB;IACI;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,qCAAqC;IACrC,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,qCAAqC;IACrC,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB,EAAE,oCAAoC;IAC3D,sCAAsC,EAAE,mCAAmC;AAC/E;;AAEA;IACI,wBAAwB,EAAE,+BAA+B;AAC7D;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,4DAA4D;IAC5D,YAAY;AAChB;;AAEA;IACI,wCAAwC;IACxC,gCAAgC,EAAE,cAAc;IAChD,aAAa;AACjB;;AAEA;IACI,uDAAuD;IACvD,wCAAwC;AAC5C;;AAEA;IACI,qDAAqD;IACrD,6DAA6D;IAC7D,wCAAwC;IACxC,2CAA2C;IAC3C,yDAAiD;IAAjD,iDAAiD,EAAE,yBAAyB;AAChF;;AAhMA;EAAA,mBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,iBAiMA;EAjMA,iBAiMA;EAjMA;AAiMA;;AAjMA;;EAAA;IAAA;EAiMA;AAAA;;AAjMA;EAAA;AAiMA;;AAjMA;EAAA;AAiMA;;AAjMA;EAAA,sBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,sBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA;AAiMA;;AAjMA;EAAA,oBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,oBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,oBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,oBAiMA;EAjMA;AAiMA;;AAjMA;EAAA;AAiMA;;AAjMA;EAAA;AAiMA;;AAjMA;EAAA,0EAiMA;EAjMA,8FAiMA;EAjMA;AAiMA;;AAjMA;EAAA,+EAiMA;EAjMA,mGAiMA;EAjMA;AAiMA;;AAjMA;EAAA,0CAiMA;EAjMA,uDAiMA;EAjMA;AAiMA;;AAjMA;EAAA,8BAiMA;EAjMA;AAiMA;;AAjMA;EAAA;AAiMA;;AAjMA;EAAA;AAiMA;;AAjMA;EAAA;AAiMA;;AAjMA;EAAA;AAiMA;;AAjMA;EAAA,kBAiMA;EAjMA;AAiMA;;AAjMA;EAAA;AAiMA;;AAjMA;EAAA,sBAiMA;EAjMA;AAiMA;;AAjMA;EAAA,oBAiMA;EAjMA;AAiMA;;AAjMA;EAAA;AAiMA;;AAjMA;;EAAA;IAAA;EAiMA;;EAjMA;IAAA,gBAiMA;IAjMA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA,qBAiMA;IAjMA;EAiMA;;EAjMA;IAAA,eAiMA;IAjMA,eAiMA;IAjMA;EAiMA;;EAjMA;IAAA,iBAiMA;IAjMA,iBAiMA;IAjMA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA,oBAiMA;IAjMA;EAiMA;AAAA;;AAjMA;;EAAA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA,wBAiMA;IAjMA,kEAiMA;IAjMA;EAiMA;AAAA;;AAjMA;;EAAA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;AAAA;;AAjMA;;EAAA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;AAAA;;AAjMA;;EAAA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;AAAA;;AAjMA;;EAAA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;AAAA;;AAjMA;;EAAA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;AAAA;;AAjMA;;EAAA;IAAA,gBAiMA;IAjMA;EAiMA;;EAjMA;IAAA,gBAiMA;IAjMA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA,8BAiMA;IAjMA;EAiMA;;EAjMA;IAAA,4BAiMA;IAjMA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA,sBAiMA;IAjMA;EAiMA;;EAjMA;IAAA,kBAiMA;IAjMA;EAiMA;;EAjMA;IAAA,kBAiMA;IAjMA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA,iBAiMA;IAjMA;EAiMA;;EAjMA;IAAA,mBAiMA;IAjMA;EAiMA;;EAjMA;IAAA;EAiMA;;EAjMA;IAAA,kBAiMA;IAjMA;EAiMA;;EAjMA;IAAA,oBAiMA;IAjMA;EAiMA;;EAjMA;IAAA,oBAiMA;IAjMA;EAiMA;;EAjMA;IAAA,oBAiMA;IAjMA;EAiMA;;EAjMA;IAAA,0EAiMA;IAjMA,8FAiMA;IAjMA;EAiMA;AAAA;;AAjMA;;EAAA;IAAA;EAiMA;;EAjMA;IAAA;EAiMA;AAAA;;AAjMA;;EAAA;IAAA;EAiMA;AAAA;;AAjMA;;EAAA;IAAA;EAiMA;AAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;0,1000;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900;1,1000&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Pacifico&display=swap');\n\n@import '@mantine/core/styles.css';\n@import '@mantine/carousel/styles.css';\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nbody {\n    -webkit-tap-highlight-color: transparent;\n    font-family: Inter, serif;\n}\n\n.App {\n}\n\n.App-logo {\n    height: 40vmin;\n    pointer-events: none;\n}\n\n.message-background {\n    background-image: url('data:image/svg+xml;base64,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');\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n\n.placeholder-presales::placeholder {\n    font-size: 12px;\n    text-align: left;\n}\n\n.placeholder-left::placeholder {\n    @apply text-left;\n    padding-left: 5px;\n}\n\n.placeholder-right::placeholder {\n    @apply text-right;\n    padding-right: 5px;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    .App-logo {\n        animation: App-logo-spin infinite 20s linear;\n    }\n}\n\n.App-header {\n    background-color: #282c34;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n}\n\n.App-link {\n    color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.font-open-sans {\n    font-family: 'Open Sans', sans-serif;\n    color: rgb(103, 116, 142);\n}\n\n.login-header-background {\n    background-image: linear-gradient(310deg, #C5B17B, #E6DAC1)\n}\n\n.text-gradient {\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    position: relative;\n    z-index: 1;\n}\n\n.text-gradient.text-info {\n    background-image: linear-gradient(310deg, #C5B17B, #E6DAC1);\n}\n\n.text-gradient.text-info-red {\n    background-image: linear-gradient(310deg, #701F1D, #FF1D14);\n}\n\nbutton:focus {\n    outline: none;\n}\n\n.blue-gradient-button:hover {\n    transform: scale(1.02);\n    transition-duration: 300ms;\n}\n\n.grow-on-hover-2:hover {\n    transform: scale(1.02);\n    transition-duration: 300ms;\n}\n\n.grow-on-hover-5:hover {\n    transform: scale(1.05);\n    transition-duration: 300ms;\n}\n\n.grow-on-hover-15:hover {\n    transform: scale(1.15);\n    transition-duration: 300ms;\n}\n\n.login-switch-backcolor {\n    background-color: #22C9FD;\n}\n\n.grow-div {\n    max-height: 1000px;\n    transition: max-height 0.5s ease-in;\n}\n\n.hide {\n    opacity: 0;\n    transition: opacity 1s linear;\n    -webkit-transition: opacity 1s linear;\n    -moz-transition: opacity 1s linear;\n    -o-transition: opacity 1s linear;\n}\n\n.show {\n    opacity: 1;\n    transition: opacity 1s linear;\n    -webkit-transition: opacity 1s linear;\n    -moz-transition: opacity 1s linear;\n    -o-transition: opacity 1s linear;\n}\n\nth {\n    text-align: left;\n}\n\ntd {\n    text-align: left;\n    padding-right: 25px;\n}\n\n.rotate-on-hover {\n    display: inline-block; /* Ensure the element has a layout */\n    transition: transform 0.3s ease-in-out; /* Smooth transition for rotation */\n}\n\n.rotate-on-hover:hover {\n    transform: rotate(90deg); /* Rotate 90 degrees on hover */\n}\n\n.flying-image {\n    position: absolute;\n    width: 100px;\n    height: 100px;\n    transition: transform 1s ease-in-out, opacity 1s ease-in-out;\n    z-index: 999;\n}\n\ninput:focus {\n    background-color: transparent !important;\n    border-color: #f1f5f9 !important; /* slate-100 */\n    outline: none;\n}\n\ninput:-webkit-autofill:focus {\n    box-shadow: 0 0 0px 1000px transparent inset !important;\n    background-color: transparent !important;\n}\n\ninput:-webkit-autofill {\n    box-shadow: 0 0 0 1000px transparent inset !important;\n    -webkit-box-shadow: 0 0 0 1000px transparent inset !important;\n    background-color: transparent !important;\n    -webkit-text-fill-color: inherit !important;\n    transition: background-color 5000s ease-in-out 0s; /* Chrome autofill hack */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
